module.exports = __webpack_public_path__ + "static/media/ikh_logo_payoff.4889916b.svg";